<ng-container>
  <div class="wrapper__form">
    <app-form
      [fields]="formFieldsReclamoDirecto"
      [title]="proconText['tramite-sic-procon']['reclamo-directo']"
      [titleModalVisibility]="true"
      [titleContentModalText]="
        proconText['tramite-sic-procon']['reclamo-proveedor']
      "
      [tooltipVisibility]="true"
      [tooltipMessage]="proconText['tramite-sic-procon']['clic-aca']"
      [titleSizeModal]="'xl'"
      [titleModal]="'comun-label.ver-mas' | translate"
      (changeAction)="validarFormulario($event)"
      (changedControl)="validarCampos($event)"
      [withSubmitButton]="false"
      [idEntidad]="entidadId"
    />
    <div *ngIf="mostrarComponente">
      <app-cargue-archivos-tramite
        *ngIf="archivosPrecargados.length > 0"
        [idTipoTramite]="Constants.SIC_PROCON"
        [paso]="3"
        [idTramite]="tramiteSic?.id??0"
        (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
        (archivosCargados)="validarArchivosCargados($event)"
        [enviar]="guardarArchivos"
        [codigoPretencion]="jsonReclamacion"
        [reglaRequerido]="JSON.stringify(jsonReclamacion)"
        [archivosPreCargados]="archivosPrecargados"
        [elminarArchivo]="eliminarArchivo"
        (guardo)="subirArchivo($event)"
        >
      </app-cargue-archivos-tramite>
      <app-cargue-archivos-tramite
        *ngIf="archivosPrecargados.length == 0"
        [idTipoTramite]="Constants.SIC_PROCON"
        [paso]="3"
        [idTramite]="tramiteSic?.id??0"
        (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
        (archivosCargados)="validarArchivosCargados($event)"
        [enviar]="guardarArchivos"
        [codigoPretencion]="jsonReclamacion"
        [reglaRequerido]="JSON.stringify(jsonReclamacion)"
        [archivosPreCargados]="archivosPrecargados"
        [elminarArchivo]="eliminarArchivo"
        (guardo)="subirArchivo($event)"
        >
      </app-cargue-archivos-tramite>
      <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="validarRegla()">
        <i class="bi bi-info-circle me-2"></i>
        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
      </div>
    </div>
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        [attr.aria-label]="proconText['botones-envio']['atras']">
        {{ proconText['botones-envio']['atras'] }}
      </button>

      <button
        type="button"
        class="btn-govco fill-btn-govco w-auto"
        [disabled]="formReclamoDirecto.invalid"
        (click)="pasarAProteccionQueRequiere($event, true)"
        [attr.aria-label]="proconText['botones-envio']['guardar-sin-enviar']">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>

      <button
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="onClickProteccionRequiere($event)"
        [attr.aria-label]="proconText['siguiente']">
        {{ proconText['siguiente'] }}
      </button>
    </div>
    <!--[disabled]="formReclamoDirecto.invalid"-->
  </div>
</ng-container>
